import {IssuanceTrainingCodes} from "./components/accreditation/IssuanceTrainingCodes";
import {FieldInstances} from "./components/FieldInstances";
import {IssuanceEarnedPoints} from "./components/accreditation/IssuanceEarnedPoints";

const ContentEarningEvents = props => {

  const values = props.contentAccreditationValues;
  const rules = props.contentRules;

  const prefix = `tgbl_cred_content_accreditation_values[${rules.earning_event.value}]`;

  const productId = tangibleFields.render({
    type: 'text',
    name: `${prefix}[product_identifier]`,
    value: values.product_identifier,
    label: 'Product ID',
    description: 'Product ID for reporting',
  })

  const trainingCodes = <IssuanceTrainingCodes
    name={`${prefix}[training_codes]`}
    title={rules.accreditation_code_label}
    value={values.training_codes ?? []}
  />

  const fieldInstances = <FieldInstances
    name={`${prefix}[accreditation_fields]`}
    value={values.accreditation_fields}
    fieldDefs ={rules.accreditation_fields}
    description={'These fields can be edited in Earning Event settings'}
  />

  const earnedPoints = <IssuanceEarnedPoints
    prefix={prefix}
    value={values.earned_points}
    pointTypes={rules.point_types}
  />

  return (
    <>
      <h3>Accreditation rules for event '{rules.earning_event.label}'</h3>
      {tangibleFields.render({
        type: 'hidden',
        name: `${prefix}[earning_event]`,
        value: rules.earning_event.value,
      })}

      <div className="tgbl-accreditation-product-id tgbl-field-block">
        {productId}
      </div>

      <div className="tgbl-accreditation-fields tgbl-field-block">
        {fieldInstances}
      </div>

      <div className="tgbl-content-training-codes tgbl-field-block">
        {trainingCodes}
      </div>

      <div className="tgbl-content-earned-points tgbl-field-block">
        {
          rules.point_types && rules.point_types.length
            ? earnedPoints
            : <h5>No point types defined for this post type</h5>
        }
      </div>

    </>
  );


}

export {ContentEarningEvents}
